import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AuthService from "services/auth";
import Constants from "app_constants";
import Utils from "utils";
import LoginView from "./view";

class PasswordReset extends Component {
  state = {
    email: "",
    error: false,
    resetPasswordModal: false,
  };

  resetPassword = () => {
    const { email } = this.state;

    if (!Utils.validator(email)) {
      this.setState({ error: Constants.errors.auth });
    } else {
      AuthService.resetPassword({ email }).then((res) => {
        if (res && res === "success") {
          this.setState({ resetPasswordModal: true, email: "" });
        } else {
          this.setState({ error: Constants.errors.general });
        }
      });
    }
  };

  setFormData = (type, value) => this.setState({ [type]: value });

  showResetPasswordModal = (value) =>
    this.setState({ resetPasswordModal: value });

  render() {
    const { email, resetPasswordModal, error } = this.state;
    return (
      <LoginView
        error={error}
        email={email}
        resetPassword={this.resetPassword}
        setFormData={this.setFormData}
        resetPasswordModal={resetPasswordModal}
        showResetPasswordModal={this.showResetPasswordModal}
      />
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PasswordReset));
